export const LOAD_PAYSLIP_COMPANY_OFFICES = 'LOAD_PAYSLIP_COMPANY_OFFICES'
export const LOAD_PAYSLIP_OFFICE_EMPLOYEES = 'LOAD_PAYSLIP_OFFICE_EMPLOYEES'
export const LOAD_CURRENT_EMPLOYEE_PAYSLIP = 'LOAD_CURRENT_EMPLOYEE_PAYSLIP'
export const LOAD_PAYSLIP_STATUS = 'LOAD_PAYSLIP_STATUS'
